var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageHeader',{attrs:{"page-title":"My Account"}}),_c('FormGenerator',{attrs:{"fieldsets":_vm.data.formGenerator.fields.fieldsets,"prefill":_vm.prefill,"novalidate":""},on:{"submitted":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }